// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"pv-z","hovered":"qv-z","hoverImage":"rv-z","mainImage":"sv-z","imageNoBackground":"tv-z","fullSizeImage":"uv-z"};